import React, { createContext, useContext, useState, useEffect } from 'react'

interface MercadinhoInitialState {
  isMercadinho: boolean
  mercadinhoID: number
  setIsMercadinho: (value: boolean) => void
  toggleMercadinho: () => void
  setMercadinhoID: (value: number) => void
}

export const initialState: any = {
  isMercadinho: false,
  mercadinhoID: 0,
}

const MercadinhoContext = createContext<MercadinhoInitialState | undefined>(initialState)

// @ts-ignore
export const MercadinhoProvider = ({ children }) => {
  const getInitialState = () => {
    if (typeof window !== 'undefined') {
      const savedState = localStorage.getItem('mercadinho-config')



      return savedState ? JSON.parse(savedState) : initialState
    }
    return false
  };

  const [isMercadinho, setIsMercadinho] = useState(getInitialState().isMercadinho)
  const [mercadinhoID, setMercadinhoID] = useState(getInitialState().mercadinhoID)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('mercadinho-config', JSON.stringify({isMercadinho, mercadinhoID}))
    }
  }, [isMercadinho, mercadinhoID])
  const toggleMercadinho = () => {
    setIsMercadinho((prev: any) => !prev)
  }

  return (
    <MercadinhoContext.Provider value={{ isMercadinho, mercadinhoID, setIsMercadinho, setMercadinhoID, toggleMercadinho }}>
      {children}
    </MercadinhoContext.Provider>
  )
}

export const useMercadinho = () => {
  const context = useContext(MercadinhoContext)

  if (context === undefined) {
    throw new Error('useMercadinho deve ser usado dentro de um MercadinhoProvider')
  }

  return context
}
